const action = "DEPLOYMENT_DELETE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const deleteRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};

export const deleteSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = (response) => ({
  type: CLEAR
});

export const deleteFailure = (error) => ({
  type: FAILURE,
  payload: error
});
